import React from 'react';
import { omit } from 'lodash';
import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';

import { PollInput, PollInputOwnProps } from './poll-input';

type Props = Omit<PollInputOwnProps, 'onChange' | 'value'>;

/**
 * By default the form validation mode is set to `mode: 'onSubmit'`.
 * This means the validation will be shown after submitting the form.
 * You probably want to set this option to `all` to have immediate feedback when a field does not pass the added rules.
 * useForm({ mode: 'all' });
 */
export function PollInputHookForm<T extends FieldValues>(
  props: Props & UseControllerProps<T>,
) {
  const { field } = useController(props);
  return (
    <PollInput
      {...props}
      {...field}
    />
  );
}

const ReduxFormField = ({ input, ...props }: WrappedFieldProps & Props) => {
  return (
    <PollInput
      {...input}
      {...omit(props, ['meta', 'input'])}
    />
  );
};

export default ({ name, ...props }: BaseFieldProps & Props) => (
  <Field
    name={name}
    component={ReduxFormField}
    props={props}
  />
);
